// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settings_wrapper__hsdVT","container":"settings_container__31oll","back":"settings_back__2OeK3","loader":"settings_loader__vmead"};